import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-status-select',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <app-form-group [fbControl]="fbControl" [width]="230" [marginBottom]="20">
            <app-form-label>Состояние</app-form-label>
            <app-form-select [fbControl]="fbControl" [values]="statusProvider.data$ | async" [placeholder]="null"></app-form-select>
        </app-form-group>
    `
})

export class StatusSelectComponent {
    @Input() fbControl: FormControl = new FormControl();
    constructor(
        @Inject('StatusProvider') public statusProvider
    ) {
    }
}
